<template>
  <transition name="modal">
    <div class="modal-mask" @click="$emit('close')">
      <div class="modal-wrapper middle" role="document">
        <div class="modal-container">
          <div class="modal-content" @click.stop>
            <div class="modal-header">
              <div class="row">
                <div class="col-xs-10">Share Product</div>
                <div class="col-xs-2">
                  <button
                    type="button"
                    class="close"
                    @click="$emit('close')"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/_global/Close.svg'"
                      width="50px"
                      height="auto"
                      class="icon"
                    />
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <textarea
                class="form-control"
                ref="shareLink"
                style="resize: vertical"
                onclick="this.select()"
                readonly="true"
                v-model="message"
              ></textarea>
              <div class="text-center" style="margin-top: 15px">
                <a
                  href="javascript:void(0);"
                  class="btn btn-primary"
                  v-clipboard:copy="message"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  style="position: relative"
                >
                  <span class="glyphicon glyphicon-file"></span> Copy
                  <transition
                    enter-active-class="animated fadeInUp"
                    leave-active-class="animated fadeOut"
                  >
                    <span class="tooltiptext" v-if="showCopy">Copied!</span>
                  </transition>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['productid', 'pageid'],
  data: function () {
    return {
      showCopy: false
    }
  },
  computed: {
    id: function () {
      return this.productid
    },
    message: function () {
      return 'https://m.me/' + this.pageid + '?ref=askproduct_' + this.id
    }
  },
  mounted: function () {
    let vm = this
    vm.$refs.shareLink.click()
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        vm.$emit('close')
      }
    })
  },
  methods: {
    onCopy: function () {
      let vm = this
      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 1000)
    },
    onError: function () {}
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/event/ModalShareLink.vue